import { render, staticRenderFns } from "./VideoRecordQuery.vue?vue&type=template&id=605300d2&scoped=true&"
import script from "./VideoRecordQuery.vue?vue&type=script&lang=js&"
export * from "./VideoRecordQuery.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecordQuery.vue?vue&type=style&index=0&id=605300d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605300d2",
  null
  
)

export default component.exports